var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00029 5.14014L0.210292 1.89014C0.110929 1.76718 0.0449279 1.62069 0.0186542 1.4648C-0.0076196 1.30891 0.00672083 1.14888 0.0602923 1.00014C0.103031 0.861352 0.187302 0.739005 0.301742 0.649599C0.416181 0.560193 0.555284 0.50803 0.700292 0.500144H6.30029C6.45524 0.497047 6.60706 0.544031 6.73317 0.634112C6.85929 0.724194 6.95297 0.852564 7.00029 1.00014C7.05386 1.14888 7.0682 1.30891 7.04193 1.4648C7.01566 1.62069 6.94966 1.76718 6.85029 1.89014L4.00029 5.14014C3.94147 5.21688 3.86578 5.27905 3.77907 5.32183C3.69237 5.36461 3.59698 5.38687 3.50029 5.38687C3.40361 5.38687 3.30822 5.36461 3.22151 5.32183C3.13481 5.27905 3.05911 5.21688 3.00029 5.14014Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGray);
export default __webpack_public_path__ + "static/media/chevron-down-gray.adbbeb6698b889fd345ccb6141cba259.svg";
export { ForwardRef as ReactComponent };